(function () {
    'use strict';

    function initializeCareAtHomeStickyUtilities() {
        var utilities = document.querySelectorAll('.care-at-home .care-at-home__utility');
        Array.prototype.forEach.call(utilities, function (utility) {
            if (utility.__careHomeStickyReady) return;
            var hero = utility.closest('.care-at-home__hero');
            if (!hero) return;
            utility.__careHomeStickyReady = true;
            var scheduled = false;

            function update() {
                if (!document.documentElement.contains(utility)) return;
                utility.classList.toggle('care-at-home__utility--sticky', hero.getBoundingClientRect().top <= 0);
                var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                var available = Math.max(0, Math.floor(viewportHeight - utility.getBoundingClientRect().bottom - 12));
                var height = available + 'px';
                if (utility.style.getPropertyValue('--care-home-contact-max-height') !== height) {
                    utility.style.setProperty('--care-home-contact-max-height', height);
                }
            }

            function scheduleUpdate() {
                if (scheduled) return;
                scheduled = true;
                var run = function () {
                    scheduled = false;
                    update();
                };
                if (window.requestAnimationFrame) window.requestAnimationFrame(run);
                else window.setTimeout(run, 16);
            }

            window.addEventListener('scroll', scheduleUpdate, { passive: true });
            window.addEventListener('resize', scheduleUpdate);
            window.addEventListener('orientationchange', scheduleUpdate);
            window.addEventListener('load', scheduleUpdate);
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', scheduleUpdate);
                window.visualViewport.addEventListener('scroll', scheduleUpdate, { passive: true });
            }
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);
            update();
        });
    }

    function initializeCareAtHomeContacts() {
        initializeCareAtHomeStickyUtilities();
        var contacts = document.querySelectorAll('[data-care-home-contact]');
        Array.prototype.forEach.call(contacts, function (contact) {
            if (contact.__careHomeContactReady) return;
            var toggle = contact.querySelector('[data-care-home-contact-toggle]');
            var panel = contact.querySelector('[data-care-home-contact-panel]');
            if (!toggle || !panel) return;

            var baseId = panel.id || 'care-at-home-contact-panel';
            var panelId = baseId;
            var suffix = 1;
            while (document.getElementById(panelId) && document.getElementById(panelId) !== panel) {
                panelId = baseId + '-' + suffix++;
            }
            panel.id = panelId;
            toggle.setAttribute('aria-controls', panelId);
            contact.__careHomeContactReady = true;

            function isOpen() {
                return toggle.getAttribute('aria-expanded') === 'true';
            }

            function close(returnFocus) {
                toggle.setAttribute('aria-expanded', 'false');
                panel.hidden = true;
                if (returnFocus) toggle.focus();
            }

            close(false);

            toggle.addEventListener('click', function () {
                var open = !isOpen();
                toggle.setAttribute('aria-expanded', String(open));
                panel.hidden = !open;
            });

            document.addEventListener('keydown', function (event) {
                if (isOpen() && (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) {
                    event.preventDefault();
                    close(true);
                }
            });

            document.addEventListener('click', function (event) {
                if (isOpen() && !contact.contains(event.target)) close(false);
            });

            document.addEventListener('focusin', function (event) {
                if (isOpen() && !contact.contains(event.target)) close(false);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeCareAtHomeContacts);
    } else {
        initializeCareAtHomeContacts();
    }
})();
